import initSliders from '../product/slider';

let imagesEls = document.querySelectorAll('.promo-products .product-images');
imagesEls.forEach(imagesEl => initSliders(imagesEl));